/* eslint-disable import/no-anonymous-default-export */
import {
	GET_POSTS,
	NUMBER_OF_LIKES,
	GET_PERSONAL_POSTS,
	GET_PERSONAL_VIDEOS,
	IMG_UPLOADED,
	IMG_UPLOADING,
	GET_VIDEO,
	POST_LOADING
} from "../wm_actions/types";

const initialState = {
	key: localStorage.getItem("key"),
	posts: [],
	likes: null,
	isFetching: true,
	personalPosts: [],
	personalVideos: [],
	uploadedIMG: true,
	vid: [],
	videoPost: [],
	productLoading: false
};

export default function (state = initialState, action) {
	switch (action.type) {
		case GET_POSTS:
			// console.log(action.payload, 'GET_POSTS')
			return {
				...state,
				posts: action.payload,
				isFetching: false,
				vid: action.vids
			};
		case GET_VIDEO:
			// console.log(action.payload, 'GET_VIDEO')
			return {
				...state,
				videoPost: action.payload,
				isFetching: false,
				vid: action.vids
			};
		case NUMBER_OF_LIKES:
			return {
				...state,
				likes: action.payload
			};
		case GET_PERSONAL_POSTS:
			return {
				...state,
				personalPosts: action.payload
			};
		case GET_PERSONAL_VIDEOS:
			return {
				...state,
				personalVideos: action.payload
			};
		case IMG_UPLOADING:
			return {
				...state,
				uploadedIMG: false
			};
		case IMG_UPLOADED:
			return {
				...state,
				uploadedIMG: true
			};
		case POST_LOADING:
			console.log(action.payload);
			return {
				...state,
				productLoading: action.payload
			};
		default:
			return state;
	}
}
